import styles from "./Hero.module.scss";
import headerVideo from "../../static/video/heroVideo.mp4";
import Heading from "../Typography/Heading/Heading";

export default function Hero() {
  return (
    <div className={styles.hero}>
      <div className={styles.video}>
        <video src={headerVideo} autoPlay muted loop></video>
      </div>
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.title}>
            <Heading level="h1">ЭЛЕКТРОЗАПРАВОЧНЫЕ СТАНЦИИ</Heading>
          </div>
          <div className={styles.subtitle}>
            <Heading level="h4">Чистая энергия Чувашии</Heading>
          </div>
        </div>
      </div>
    </div>
  );
}
